<template>
	<div>
		<auth-container v-if="$route.name === 'SrProjectList'" :page="page">
			<h2 class="mb-4">Projects</h2>

            <div class="mx-auto">
                <b-row class="mb-3" align-v="end">
                    <b-col lg="6">
                        <b-form inline>
                            <b-input-group>
                                <b-form-input v-model="table.filter" placeholder="Search..." @input="filterChg"></b-form-input>

                                <b-input-group-append class="pointer mr-2">
                                    <b-input-group-text @click="clearFilter">
                                        <font-awesome-icon :icon="['fas', 'times']" />
                                    </b-input-group-text>
                                </b-input-group-append>
                            </b-input-group>
                            <b-button variant="primary" type="button" @click="table.showAdvancedFilter = !table.showAdvancedFilter">Advanced Filter</b-button>
                        </b-form>
                    </b-col>
                    <b-col lg="6" class="text-right">
                        <div class="ml-auto">
                            Showing {{showingFirst}} - {{showingLast}}
                            of {{table.total}}
                        </div>
                    </b-col>
                </b-row>

                <b-collapse v-model="table.showAdvancedFilter" class="my-3">
                    <b-card bg-variant="light">
                        <b-row>
                            <b-col lg="4">
                                <div class="form-group row">
                                    <label for="advancedFilter.projectNumber" class="col-lg-5 col-form-label">TPN</label>
                                    <div class="col-lg-7">
                                        <b-typeahead id="advancedFilter.projectNumber"
                                                     v-model="advancedFilter.projectNumber"
                                                     :data="advancedFilter.options.projectNumber"
                                                     :max-matches="100" :minMatchingChars="1">
                                        </b-typeahead>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.appSlo" class="col-lg-5 col-form-label">Application #</label>
                                    <div class="col-lg-7">
                                        <b-typeahead id="advancedFilter.appNum"
                                                     v-model="advancedFilter.appNum"
                                                     :data="advancedFilter.options.appNum"
                                                     :max-matches="100" :minMatchingChars="1">
                                        </b-typeahead>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.dam" class="col-lg-5 col-form-label">Dam NID_ID</label>
                                    <div class="col-lg-7">
                                        <b-typeahead id="advancedFilter.dam"
                                                     v-model="advancedFilter.dam"
                                                     :data="advancedFilter.options.dam"
                                                     :max-matches="100" :minMatchingChars="1">
                                        </b-typeahead>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.name" class="col-lg-5 col-form-label">Project Name</label>
                                    <div class="col-lg-7">
                                        <b-typeahead id="advancedFilter.name"
                                                     v-model="advancedFilter.name"
                                                     :data="advancedFilter.options.name"
                                                     :max-matches="100" :minMatchingChars="1">
                                        </b-typeahead>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.status" class="col-lg-5 col-form-label">Project Status</label>
                                    <div class="col-lg-7">
                                        <b-typeahead id="advancedFilter.status"
                                                     v-model="advancedFilter.status"
                                                     :data="setOptions.statuses"
                                                     :minMatchingChars="1" showAllResults showOnFocus>
                                        </b-typeahead>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.category" class="col-lg-5 col-form-label">Category</label>
                                    <div class="col-lg-7">
                                        <b-typeahead id="advancedFilter.category"
                                                     v-model="advancedFilter.category"
                                                     :data="setOptions.categories"
                                                     :minMatchingChars="1" showAllResults showOnFocus>
                                        </b-typeahead>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.phase" class="col-lg-5 col-form-label">Phase</label>
                                    <div class="col-lg-7">
                                        <b-typeahead id="advancedFilter.phase"
                                                     v-model="advancedFilter.phase"
                                                     :data="setOptions.phases"
                                                     :minMatchingChars="1" showAllResults showOnFocus>
                                        </b-typeahead>
                                    </div>
                                </div>
                            </b-col>
                            <b-col lg>
                                <div class="form-group row">
                                    <label for="advancedFilter.expectedCompletionDate.start" class="col-lg-3 col-form-label">Expected Completion Date</label>
                                    <div class="col-lg-9">
                                        <div class="d-flex align-items-center justify-content-start">
                                            <div class="mr-2">
                                                <b-input-group>
                                                    <b-form-datepicker id="advancedFilter.expectedCompletionDate.start" v-model="advancedFilter.expectedCompletionDate.start"
                                                                       label-no-date-selected="Start Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

                                                    <b-input-group-append class="pointer">
                                                        <b-input-group-text @click="advancedFilter.expectedCompletionDate.start = null">
                                                            <font-awesome-icon :icon="['fas', 'times']" />
                                                        </b-input-group-text>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                            <div>
                                                <b-input-group>
                                                    <b-form-datepicker id="advancedFilter.expectedCompletionDate.end" v-model="advancedFilter.expectedCompletionDate.end"
                                                                       label-no-date-selected="End Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

                                                    <b-input-group-append class="pointer">
                                                        <b-input-group-text @click="advancedFilter.expectedCompletionDate.end = null">
                                                            <font-awesome-icon :icon="['fas', 'times']" />
                                                        </b-input-group-text>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.completionSubmissionDate.start" class="col-lg-3 col-form-label">Completion Date</label>
                                    <div class="col-lg-9">
                                        <div class="d-flex align-items-center justify-content-start">
                                            <div class="mr-2">
                                                <b-input-group>
                                                    <b-form-datepicker id="advancedFilter.completionSubmissionDate.start" v-model="advancedFilter.completionSubmissionDate.start"
                                                                       label-no-date-selected="Start Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

                                                    <b-input-group-append class="pointer">
                                                        <b-input-group-text @click="advancedFilter.completionSubmissionDate.start = null">
                                                            <font-awesome-icon :icon="['fas', 'times']" />
                                                        </b-input-group-text>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                            <div>
                                                <b-input-group>
                                                    <b-form-datepicker id="advancedFilter.completionSubmissionDate.end" v-model="advancedFilter.completionSubmissionDate.end"
                                                                       label-no-date-selected="End Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

                                                    <b-input-group-append class="pointer">
                                                        <b-input-group-text @click="advancedFilter.completionSubmissionDate.end = null">
                                                            <font-awesome-icon :icon="['fas', 'times']" />
                                                        </b-input-group-text>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.completionYear" class="col-lg-3 col-form-label">Completion Year</label>
                                    <div class="col-lg-9">
                                        <b-typeahead id="advancedFilter.completionYear" style="max-width:300px"
                                                     v-model="advancedFilter.completionYear"
                                                     :data="setOptions.completionYears"
                                                     :minMatchingChars="1" showAllResults showOnFocus>
                                        </b-typeahead>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.awardDate.start" class="col-lg-3 col-form-label">Award Date</label>
                                    <div class="col-lg-9">
                                        <div class="d-flex align-items-center justify-content-start">
                                            <div class="mr-2">
                                                <b-input-group>
                                                    <b-form-datepicker id="advancedFilter.awardDate.start" v-model="advancedFilter.awardDate.start"
                                                                       label-no-date-selected="Start Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

                                                    <b-input-group-append class="pointer">
                                                        <b-input-group-text @click="advancedFilter.awardDate.start = null">
                                                            <font-awesome-icon :icon="['fas', 'times']" />
                                                        </b-input-group-text>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                            <div>
                                                <b-input-group>
                                                    <b-form-datepicker id="advancedFilter.awardDate.end" v-model="advancedFilter.awardDate.end"
                                                                       label-no-date-selected="End Date" :date-format-options="defaultDatePickerFormatDisplay"></b-form-datepicker>

                                                    <b-input-group-append class="pointer">
                                                        <b-input-group-text @click="advancedFilter.awardDate.end = null">
                                                            <font-awesome-icon :icon="['fas', 'times']" />
                                                        </b-input-group-text>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label for="advancedFilter.mapLayer.layer" class="col-lg-3 col-form-label">Regional or Political Boundary</label>
                                    <div class="col-lg-9">
                                        <div>
                                            <b-input-group>
                                                <b-form-select v-model="advancedFilter.mapLayer.layer" :options="mapLayerOptions" @change="advancedFilter.mapLayer.name = null" style="max-width:300px"></b-form-select>
                                                <b-input-group-append class="pointer">
                                                    <b-input-group-text @click="advancedFilter.mapLayer.layer = null">
                                                        <font-awesome-icon :icon="['fas', 'times']" />
                                                    </b-input-group-text>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row" v-if="advancedFilter.mapLayer.layer != null">
                                    <label for="advancedFilter.mapLayer.layer" class="col-lg-3 col-form-label">{{ advancedFilter.mapLayer.layer }}</label>
                                    <div class="col-lg-9">
                                        <div class="mb-2">
                                            <b-input-group>
                                                <b-form-select v-model="advancedFilter.mapLayer.name" :options="selectedMapLayerNames" style="max-width:300px"></b-form-select>
                                                <b-input-group-append class="pointer">
                                                    <b-input-group-text @click="advancedFilter.mapLayer.name = null">
                                                        <font-awesome-icon :icon="['fas', 'times']" />
                                                    </b-input-group-text>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </div>
                                        <b-button variant="info" @click="renderMap">Select from Map <font-awesome-icon :icon="['fas', 'map-pin']" /></b-button>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                        <hr class="my-3" />
                        <div>
                            <b-button variant="primary" type="button" @click="get" class="mr-2">Apply</b-button>
                            <b-button variant="secondary" type="button" @click="clearAdvancedFilter" class="mr-2">Clear</b-button>
                            <b-button variant="secondary" type="button" @click="table.showAdvancedFilter = false">Close</b-button>
                        </div>
                    </b-card>
                </b-collapse>

                <b-modal v-model="modals.map.show" :title="`Select ${advancedFilter.mapLayer.layer}`" scrollable size="lg">
                    <div class="map-container w-100" style="height:400px">
                        <l-map ref="leafmap" style="height: 100%; width:100%" :zoom="modals.map.zoom" :center="modals.map.center">
                            <l-control-layers position="topright"></l-control-layers>
                            <l-tile-layer v-for="tileProvider in mapBase.tileProviders"
                                          :key="tileProvider.name"
                                          :name="tileProvider.name"
                                          :visible="tileProvider.visible"
                                          :url="tileProvider.url"
                                          :attribution="tileProvider.attribution"
                                          layer-type="base" />

                            <l-layer-group layer-type="overlay" :name="advancedFilter.mapLayer.layer">
                                <l-geo-json :geojson="selectedMapLayerGeojson" :options="mapLayersOptions" :options-style="modals.map.style"></l-geo-json>
                            </l-layer-group>
                        </l-map>
                    </div>

                    <div slot="modal-footer">
                        <b-button type="button" variant="secondary" @click="modals.map.show = false" class="ml-1">Cancel</b-button>
                    </div>
                </b-modal>

                <b-table striped responsive table-class="table-fixed-height border-bottom table-grid" sticky-header="60vh"
                         small show-empty
                         :items="items" :busy="table.loading"
                         :fields="table.fields"
                         :no-local-sorting="true"
                         :sort-by.sync="table.sort"
                         :sort-desc.sync="table.reverse"
                         @sort-changed="sortChg">
                    <template #table-busy>
                        <div class="text-center my-4">
                            <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
                        </div>
                    </template>
                    <template #cell(edit)="data">
                        <router-link :to="`${data.item.id}`" append>
                            <font-awesome-icon :icon="['fas', 'edit']" />
                        </router-link>
                    </template>
                    <template #cell(appNum)="data">
                        <router-link :to="`/sr/applications/${data.item.applicationId}`">{{data.value}}</router-link>
                    </template>
                    <template #cell(damId)="data">
                        <router-link :to="`/dams/${data.value}`">{{data.item.nid_id}}</router-link>
                    </template>
                    <template #empty>
                        <h4>No records found.</h4>
                    </template>
                    <template #emptyfiltered>
                        <h4>No records found matching "{{table.filter}}".</h4>
                    </template>
                </b-table>
            </div>

			<fixed-action-bar>
				<router-link v-if="!isReadOnly" to="create" append class="btn btn-success mr-2">
					Create
				</router-link>
				<json-to-csv :api-url="`${apiUrl}/export`" :filename="apiUrl" class="mr-2" />
				<b-button v-if="isAuthorized(roleNames.superAdmin)" variant="primary" @click="page.showModal = true" class="mr-2">Import</b-button>
				<b-pagination class="ml-auto mb-0" v-if="table.total > table.itemsPerPage" size="md" :total-rows="table.total" v-model="table.currentPage" :per-page="table.itemsPerPage" @change="pageChg" />
			</fixed-action-bar>

			<b-modal v-model="page.showModal" title="Upload" scrollable size="lg">
				<error-list :errors="page.saveErrors"></error-list>
				<success-alert ref="savedAlert" text="Changes saved." />

				<vue-dropzone ref="addFile" id="addFile" :options="dropzoneOptions" @vdropzone-success="fileUploaded" @vdropzone-error="uploadError"></vue-dropzone>

				<div class="mt-3">
					<strong>IMPORTANT:</strong>
				</div>
				<ul>
					<li>Use the Download Template button to get the required columns.</li>
					<li>Column headers **must match** the template.</li>
					<li>Existing TPNs already in the database will be updated.</li>
					<li>The tpn column is required and cannot be empty.</li>
					<li>If you include an appNum or nid_id, the numbers must already exist in the corresponding database tables.</li>
				</ul>

				<div slot="modal-footer">
					<json-to-csv :json-data="template" :filename="`${apiUrl}-template`" text="Download Template" class="mr-2" />
					<b-button type="button" variant="primary" @click="page.showModal = false" class="ml-1">Close</b-button>
				</div>
			</b-modal>
		</auth-container>
		<router-view></router-view>
	</div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import _ from 'underscore';
    import L from 'leaflet';
    import { LMap, LTileLayer, LControlLayers, LGeoJson, LLayerGroup } from 'vue2-leaflet';
    import 'leaflet/dist/leaflet.css';

    export default {
        name: 'SrProjectList',
        components: {
            vueDropzone: vue2Dropzone, LMap, LTileLayer, LControlLayers, LGeoJson, LLayerGroup
        },
        data() {
            return {
                apiUrl: 'srprojects',
                page: {
                    errors: [],
                    loading: true,
                    showLogin: false,
                    saveErrors: [],
                    showModal: false
                },
                dropzoneOptions: {
                    url: '/api/srprojects/upload/',
                    headers: this.getTokenHeader().headers,
                    acceptedFiles: '.csv'
                },
                modals: {
                    map: {
                        show: false,
                        zoom: 5,
                        center: [31.224, -98.897],
                        style: {
                            weight: 1,
                            opacity: 1,
                            color: '#9dd123',
                            fillOpacity: 0.5,
                            fillColor: '#ceff5e'
                        }
                    }
                },
                table: {
                    fields: [
                        { key: 'edit', label: '', stickyColumn: true },
                        { key: 'projectNumber', label: 'TPN', sortable: true },
                        { key: 'appNum', label: 'App. #', sortable: true },
                        { key: 'damId', label: 'NID_ID', sortable: true },
                        { key: 'status', sortable: true },
                        { key: 'category', sortable: true },
                        { key: 'currentPhase', sortable: true },
                        { key: 'name', sortable: true },
                        { key: 'projectManager', sortable: true },
                        { key: 'expectedCompletionDate', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
                        { key: 'completionSubmissionDate', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
                        { key: 'awardDate', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') } },
                        { key: 'swcd', sortable: true },
                        { key: 'county', sortable: true },
                        { key: 'regionalFloodPlanningGroup', label: 'Regional Flood Planning Group', sortable: true },
                        { key: 'texasHouse', label: 'Texas House', sortable: true },
                        { key: 'texasSenate', label: 'Texas Senate', sortable: true },
                        { key: 'usHouse', label: 'US House', sortable: true },
                    ],
                    sort: 'projectNumber',
                    reverse: false,
                    itemsPerPage: 100,
                    filter: null,
                    currentPage: 1,
                    total: 0,
                    loading: false,
                    showAdvancedFilter: false
                },
                items: [],
                advancedFilter: {
                    dam: null,
                    appNum: null,
                    projectNumber: null,
                    name: null,
                    status: null,
                    category: null,
                    phase: null,
                    expectedCompletionDate: {
                        start: null,
                        end: null
                    },
                    completionSubmissionDate: {
                        start: null,
                        end: null
                    },
                    awardDate: {
                        start: null,
                        end: null
                    },
                    mapLayer: {
                        layer: null,
                        name: null
                    },
                    completionYear: null,
                    options: {
                        dam: [],
                        appNum: [],
                        projectNumber: [],
                        name: [],
                    }
                },
                setOptions: {
                    statuses: [],
                    categories: [],
                    phases: [],
                    swcds: [],
                    mapLayers: [],
                    completionYears: []
                },
                template: [{
                    tpn: null,
                    appNum: null,
                    nid_id: null,
                    status: null,
                    statusNote: null,
                    category: null,
                    phase: null,
                    name: null,
                    projectManager: null,
                    expectedCompletionDate: null,
                    completionSubmissionDate: null,
                    awardDate: null,
                    notes: null
                }]
            }
        },
        computed: {
            showingFirst() {
                return this.table.total === 0 ? 0 : (this.table.currentPage - 1) * this.table.itemsPerPage + 1
            },
            showingLast() {
                var max = (this.table.currentPage - 1) * this.table.itemsPerPage + this.table.itemsPerPage
                return max > this.table.total ? this.table.total : max;
            },
            advancedFilterDam() {
                return this.advancedFilter.dam;
            },
            advancedFilterAppNum() {
                return this.advancedFilter.appNum;
            },
            advancedFilterProjectNumber() {
                return this.advancedFilter.projectNumber;
            },
            advancedFilterName() {
                return this.advancedFilter.name;
            },
            mapLayerOptions() {
                let arr = ['SWCDs'];
                return arr.concat(this.setOptions.mapLayers.map(m => m.layer));
            },
            selectedMapLayerNames() {
                if (this.advancedFilter.mapLayer.layer == null) return [];
                if (this.advancedFilter.mapLayer.layer == 'SWCDs') return this.setOptions.swcds.list;
                let match = this.setOptions.mapLayers.filter(m => m.layer === this.advancedFilter.mapLayer.layer);
                return match.length > 0 ? match[0].list : [];
            },
            selectedMapLayerGeojson() {
                if (this.advancedFilter.mapLayer.layer == null) return null;
                if (this.advancedFilter.mapLayer.layer == 'SWCDs') return this.setOptions.swcds.geojson;
                let match = this.setOptions.mapLayers.filter(m => m.layer === this.advancedFilter.mapLayer.layer);
                return match.length > 0 ? match[0].geojson : null;
            },
            mapLayersOptions() {
                return {
                    onEachFeature: this.mapLayersOnEachFeature
                };
            },
            mapLayersOnEachFeature() {
                return (feature, layer) => {
                    let label = this.isNullOrEmpty(feature.properties.label) ? "" : feature.properties.label;
                    let popText = `<div><div><b>${label} ${feature.properties.name}</b></div>`;

                    let keys = Object.keys(feature.properties);
                    let ignoreKeys = ['id', 'name', 'label'];
                    for (let k of keys) {
                        if (!ignoreKeys.includes(k))
                            popText += `<div>${k} - ${feature.properties[k]}</div>`;
                    }
                    popText += '</div>';

                    layer.on({
                        click: this.mapLayerClick
                    });

                    layer.bindTooltip(
                        popText,
                        { permanent: false, sticky: true });
                };
            },
        },
        async created() {
            await this.get();
        },
        watch: {
            '$route': 'get',
            advancedFilterAppNum: _.debounce(function (query) { this.find('appNum', query) }, 500),
            advancedFilterDam: _.debounce(function (query) { this.findDams('nid_id', query) }, 500),
            advancedFilterProjectNumber: _.debounce(function (query) { this.find('projectNumber', query) }, 500),
            advancedFilterName: _.debounce(function (query) { this.find('name', query) }, 500)
        },
        methods: {
            getDb() {
                let sort = this.table.reverse ? this.table.sort + '_desc' : this.table.sort;
                let filter = this.table.filter !== null ? `&filter=${encodeURIComponent(this.table.filter)}` : '';

                let filterComplex = '';
                let filterValues = [];
                if (!this.isNullOrEmpty(this.advancedFilter.dam)) {
                    filterValues.push(`dam:${this.advancedFilter.dam}`);
                }
                if (!this.isNullOrEmpty(this.advancedFilter.appNum)) {
                    filterValues.push(`appNum:${this.advancedFilter.appNum}`);
                }
                if (!this.isNullOrEmpty(this.advancedFilter.projectNumber)) {
                    filterValues.push(`projectNumber:${this.advancedFilter.projectNumber}`);
                }
                if (!this.isNullOrEmpty(this.advancedFilter.name)) {
                    filterValues.push(`name:${this.advancedFilter.name}`);
                }
                if (!this.isNullOrEmpty(this.advancedFilter.status)) {
                    filterValues.push(`status:${this.advancedFilter.status}`);
                }
                if (!this.isNullOrEmpty(this.advancedFilter.category)) {
                    filterValues.push(`category:${this.advancedFilter.category}`);
                }
                if (!this.isNullOrEmpty(this.advancedFilter.phase)) {
                    filterValues.push(`phase:${this.advancedFilter.phase}`);
                }
                if (!this.isNullOrEmpty(this.advancedFilter.awardDate.start) || !this.isNullOrEmpty(this.advancedFilter.awardDate.end)) {
                    let s = this.advancedFilter.awardDate.start;
                    let e = this.advancedFilter.awardDate.end;
                    s = s === null ? 'any' : s;
                    e = e === null ? 'any' : e;
                    filterValues.push(`awardDate:${s},${e}`);
                }
                if (!this.isNullOrEmpty(this.advancedFilter.expectedCompletionDate.start) || !this.isNullOrEmpty(this.advancedFilter.expectedCompletionDate.end)) {
                    let s = this.advancedFilter.expectedCompletionDate.start;
                    let e = this.advancedFilter.expectedCompletionDate.end;
                    s = s === null ? 'any' : s;
                    e = e === null ? 'any' : e;
                    filterValues.push(`expectedCompletionDate:${s},${e}`);
                }
                if (!this.isNullOrEmpty(this.advancedFilter.completionSubmissionDate.start) || !this.isNullOrEmpty(this.advancedFilter.completionSubmissionDate.end)) {
                    let s = this.advancedFilter.completionSubmissionDate.start;
                    let e = this.advancedFilter.completionSubmissionDate.end;
                    s = s === null ? 'any' : s;
                    e = e === null ? 'any' : e;
                    filterValues.push(`completionSubmissionDate:${s},${e}`);
                }

                if (!this.isNullOrEmpty(this.advancedFilter.mapLayer.layer) && !this.isNullOrEmpty(this.advancedFilter.mapLayer.name)) {
                    let s = this.advancedFilter.mapLayer.layer;
                    let e = this.advancedFilter.mapLayer.name;
                    filterValues.push(`mapLayer:${s},${e}`);
                }

                if (filterValues.length > 0) filterComplex = '&filterComplex=' + filterValues.join('|');

                return this.$http.get(`${this.apiUrl}?sort=${sort}&page=${this.table.currentPage}&perPage=${this.table.itemsPerPage}${filter}${filterComplex}`, this.getTokenHeader());
            },
            async filterChg() {
                this.table.currentPage = 1;
                _.debounce(await this.get(), 500);
            },
            async pageChg(page) {
                this.table.currentPage = page;
                await this.get();
            },
            async sortChg(ctx) {
                this.table.sort = ctx.sortBy;
                this.table.reverse = ctx.sortDesc;
                this.table.specialSort = undefined;

                await this.get();
            },
            async get() {
                this.page.errors = [];
                this.table.loading = true;

                try {
                    const response1 = await this.$http.get(`${this.apiUrl}/options`, this.getTokenHeader());
                    this.setOptions = response1.data;

                    const response = await this.getDb();
                    this.log(response.data);

                    if (response.data.items.length == 0 && this.table.currentPage > 1) {
                        this.table.currentPage--;
                        await this.get();
                    }

                    this.items = response.data.items;
                    this.table.total = response.data.total;
                } catch (error) {
                    if (this.isApiUnauthorized(error)) this.page.showLogin = true;
                    else this.page.errors = this.logError(error);
                }

                this.table.loading = false;
                this.page.loading = false;
            },
            async fileUploaded(file, response) {
                this.log(file);
                this.log(response);
                this.page.saveErrors = [];
                await this.get();
            },
            uploadError(file, message, xhr) {
                this.log(file);
                this.log(xhr);
                this.page.saveErrors.push(message);
            },
            async find(field, query) {
                try {
                    const response = await this.$http.get(`/${this.apiUrl}/find/${field}/${query}`, this.getTokenHeader());
                    this.advancedFilter.options[field] = response.data != '' ? response.data : [];
                } catch (error) {
                    this.page.errors = this.logError(error);
                }
            },
            async findDams(field, query) {
                try {
                    const response = await this.$http.get(`/dams/find/${field}/${query}`, this.getTokenHeader());
                    this.advancedFilter.options.dam = response.data != '' ? response.data : [];
                } catch (error) {
                    this.page.errors = this.logError(error);
                }
            },
            async clearFilter() {
                this.table.filter = null;
                await this.get();
            },
            async clearAdvancedFilter() {
                this.advancedFilter = {
                    dam: null,
                    appNum: null,
                    projectNumber: null,
                    name: null,
                    status: null,
                    category: null,
                    phase: null,
                    expectedCompletionDate: {
                        start: null,
                        end: null
                    },
                    completionSubmissionDate: {
                        start: null,
                        end: null
                    },
                    awardDate: {
                        start: null,
                        end: null
                    },
                    mapLayer: {
                        layer: null,
                        name: null
                    },
                    completionYear: null,
                    options: {
                        dam: [],
                        appNum: [],
                        projectNumber: [],
                        name: [],
                    }
                };

                await this.get();
            },
            mapLayerClick(e) {
                let item = e.target.feature.properties;
                if (this.advancedFilter.mapLayer.layer === 'SWCDs')
                    this.advancedFilter.mapLayer.name = item.id;
                else
                    this.advancedFilter.mapLayer.name = item.name;
                this.modals.map.show = false;
            },
            renderMap() {
                this.modals.map.show = true;

                this.$nextTick(function () {
                    window.dispatchEvent(new Event('resize'));
                });
            },
        }
    }
</script>